import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const ConceptoImpuestosTrasladosIva = ({ data, onChange }) => {

  const handleImpuestosTipoChange = (event) => {
    const { value } = event.target;

    onChange({
      ...data,
      TipoFactor: value
    });
  }

  const handleTasaCuotaChange = (event) => {
    const { name, value } = event.target;

    onChange({
      ...data,
      [name]: value
    });
  }

  return (
    <div className="mt-2">

      <Row>
        <Col>
          IVA
        </Col>
      </Row>

      <Row className="form-inline control-wrapper">
        <Col xs="auto">
          <Form.Check
            type='radio'
            id="traslados_iva_tasa"
            name="traslados_iva_tipo"
            label="Tasa"
            value="Tasa"
            custom={ true }
            checked={ data.TipoFactor === 'Tasa' }
            onChange={ handleImpuestosTipoChange }
          />
          { ['Tasa', 'Cuota'].indexOf(data.TipoFactor) !== -1 && (
            <Form.Control type="number"
              name="TasaOCuota"
              label=" "
              min="0"
              max="16"
              className="text-right"
              placeholder={ data.TipoFactor }
              value={ data.TasaOCuota || '' }
              onChange={ handleTasaCuotaChange }
            />
          )}
        </Col>
      </Row>

      <Row className="mt-1">
        <Col xs="auto">
          <Form.Check
            type='radio'
            id="traslados_iva_exento"
            name="traslados_iva_tipo"
            label="Exento"
            value="Exento"
            custom={ true }
            checked={ data.TipoFactor === 'Exento' }
            onChange={ handleImpuestosTipoChange }
          />
        </Col>
      </Row>

    </div>
  );
}

export default ConceptoImpuestosTrasladosIva;
